export function contracttoBuyandSellResidential2026() {
return [   // Release 2025-12-21 22:28:28
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 223.575,
   left: 407.16,
   width: 155.04,
   height: 15.130
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 315.28,
   left: 125.0,
   width: 449.542,
   height: 12.36
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 348.52,
   left: 96.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 365.8,
   left: 95.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 383.08,
   left: 95.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 379.443,
   left: 145.811,
   width: 428.312,
   height: 13.168
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.418,
   left: 121.8,
   width: 463.091,
   height: 13.822
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.676,
   left: 437.28,
   width: 133.549,
   height: 10.549
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 473.238,
   left: 54.3275,
   width: 535.5295,
   height: 228.8379
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 702.1928,
   left: 110.64,
   width: 454.68,
   height: 13.1672
}
,
{
   page: 1,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.36,
   left: 280.92,
   width: 55.08,
   height: 12.36
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 146.28,
   left: 91.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 163.56,
   left: 91.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 180.84,
   left: 91.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 198.12,
   left: 91.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 331.202,
   left: 71.3458,
   width: 511.3112,
   height: 147.673
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Personal Property Agreement", 
   isText: false,
   type: "checkbox",
   top: 478.92,
   left: 77.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 581.893,
   left: 71.3458,
   width: 513.2742,
   height: 93.346
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 676.2,
   left: 109.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 676.2,
   left: 154.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 58.56,
   left: 77.04,
   width: 249.96,
   height: 12.84
}
,
{
   page: 2,
   name: "Storage Facilities", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 72.135,
   left: 77.04,
   width: 470.04,
   height: 12.185
}
,
{
   page: 2,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 138.419,
   left: 72.0003,
   width: 510.6557,
   height: 99.237
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 238.2,
   left: 108.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeSellerDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 238.2,
   left: 153.72,
   width: 10.735,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 284.28,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 314.04,
   left: 386.52,
   width: 10.08,
   height: 10.735
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 314.04,
   left: 431.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 375.674,
   left: 66.7639,
   width: 521.1291,
   height: 82.873
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 477,
   left: 103.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 488.293,
   left: 70.0367,
   width: 519.1653,
   height: 52.109
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.935,
   left: 346.44,
   width: 154.92,
   height: 12.185
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 561.48,
   left: 103.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Other Rights Relating to Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 584.512,
   left: 71.3457,
   width: 516.5473,
   height: 67.818
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 653.16,
   left: 105.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 742.56,
   left: 165.6,
   width: 400.08,
   height: 12.84
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 47.88,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Water Stock Field", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 58.909,
   left: 72.6549,
   width: 513.9291,
   height: 48.837
}
,
{
   page: 3,
   name: "Time of Day Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 248.52,
   left: 402,
   width: 178.2,
   height: 20.76
}
,
{
   page: 3,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 273.84,
   left: 321.36,
   width: 78.60,
   height: 17.76
}
,
{
   page: 3,
   name: "Alternative Earnest Money Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 270.84,
   left: 402.24,
   width: 177.72,
   height: 26.52
}
,
{
   page: 3,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 317.64,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Record Title Deadline and Tax Certificate", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 314.64,
   left: 402.12,
   width: 177.96,
   height: 24.72
}
,
{
   page: 3,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 343.8,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Record Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 340.8,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 370.2,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "OffRecord Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 367.2,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 396.6,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "OffRecord Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 393.6,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 423.0,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 420,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 445.846,
   left: 321.0,
   width: 79.32,
   height: 16.560
}
,
{
   page: 3,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 446.846,
   left: 401.88,
   width: 178.44,
   height: 16.560
}
,
{
   page: 3,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 477.2,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Association Documents Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 475.2,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 503.6,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Association Documents Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 501.6,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 541.52,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 539.52,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 567.92,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 565.92,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 606.56,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 604.56,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 632.96,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 630.96,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 659.36,
   left: 321.24,
   width: 78.84,
   height: 17.76
}
,
{
   page: 3,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 657.36,
   left: 402.12,
   width: 177.96,
   height: 24.96
}
,
{
   page: 3,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 683.52,
   left: 321.0,
   width: 79.32,
   height: 17.76
}
,
{
   page: 3,
   name: "Buyers Credit Information Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 683.52,
   left: 401.88,
   width: 178.44,
   height: 17.52
}
,
{
   page: 3,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 702.24,
   left: 321.0,
   width: 79.32,
   height: 17.76
}
,
{
   page: 3,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 702.24,
   left: 401.88,
   width: 178.44,
   height: 17.76
}
,
{
   page: 3,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 721.2,
   left: 321.0,
   width: 79.32,
   height: 17.76
}
,
{
   page: 3,
   name: "Existing Loan Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 721.2,
   left: 401.88,
   width: 178.44,
   height: 17.76
}
,
{
   page: 3,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 740.16,
   left: 321.0,
   width: 79.32,
   height: 17.76
}
,
{
   page: 3,
   name: "Existing Loan Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 740.16,
   left: 401.88,
   width: 178.44,
   height: 17.76
}
,
{
   page: 4,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 43.48,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Loan Transfer Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 42.48,
   left: 402.0,
   width: 176.848,
   height: 19.995
}
,
{
   page: 4,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 65.2,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 63.725,
   left: 402.0,
   width: 176.848,
   height: 20.235
}
,
{
   page: 4,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 102.24,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 99.24,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 130.32,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 127.32,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 158.4,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 155.4,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 196.421,
   left: 321.36,
   width: 78.60,
   height: 17.520
}
,
{
   page: 4,
   name: "New ILC or New Survey Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 194.16,
   left: 402.0,
   width: 176.848,
   height: 19.724
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 219.12,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "New ILC or New Survey Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 215.12,
   left: 402.0,
   width: 176.848,
   height: 23.161
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 242.84,
   left: 321.36,
   width: 78.60,
   height: 16.52
}
,
{
   page: 4,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 240.984,
   left: 402.0,
   width: 176.848,
   height: 20.925
}
,
{
   page: 4,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 280.88,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Water Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 275.88,
   left: 402.0,
   width: 176.848,
   height: 28.80
}
,
{
   page: 4,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 313.24,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Mineral Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 309.24,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 341.32,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 337.32,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 369.4,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 365.4,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 397.48,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 393.48,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 425.56,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 421.56,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 454.64,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 449.64,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 481.72,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 477.72,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 508.44,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 506.44,
   left: 402.0,
   width: 176.848,
   height: 20.378
}
,
{
   page: 4,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 529.4,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 528.4,
   left: 402.0,
   width: 176.848,
   height: 20.235
}
,
{
   page: 4,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 551.36,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "LeadBased Paint Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 551.36,
   left: 402.0,
   width: 176.848,
   height: 17.76
}
,
{
   page: 4,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 586.44,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 581.44,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 614.52,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 609.52,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 638.6,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 670.003,
   left: 321.36,
   width: 78.60,
   height: 17.760
}
,
{
   page: 4,
   name: "Acceptance Deadline Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 666.68,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "Acceptance Deadline Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 694.76,
   left: 402.0,
   width: 176.848,
   height: 26.52
}
,
{
   page: 4,
   name: "Section Reference 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 722.48,
   left: 69.0,
   width: 29.88,
   height: 17.76
}
,
{
   page: 4,
   name: "Section Title 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 722.48,
   left: 100.44,
   width: 219.00,
   height: 17.76
}
,
{
   page: 4,
   name: "Date Section Date 1", 
   fontSize: 9,
   type: "date",
   top: 722.48,
   left: 321.36,
   width: 78.60,
   height: 17.76
}
,
{
   page: 4,
   name: "Section Deadline 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 722.48,
   left: 402.0,
   width: 176.848,
   height: 17.76
}
,
{
   page: 4,
   name: "Section Reference 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 741.44,
   left: 69.0,
   width: 29.88,
   height: 17.52
}
,
{
   page: 4,
   name: "Section Title 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 741.44,
   left: 100.44,
   width: 219.00,
   height: 17.52
}
,
{
   page: 4,
   name: "Date Section Date 2", 
   fontSize: 9,
   type: "date",
   top: 741.44,
   left: 321.36,
   width: 78.60,
   height: 17.52
}
,
{
   page: 4,
   name: "Section Deadline 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 741.44,
   left: 402.0,
   width: 176.848,
   height: 17.52
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 307.08,
   left: 73.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 307.08,
   left: 117.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 404.056,
   left: 288.836,
   width: 96.186,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 424.96,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 447.04,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Assumption Balance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.12,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.2,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 513.28,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Item 7 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 535.36,
   left: 118.56,
   width: 52.20,
   height: 15.467
}
,
{
   page: 5,
   name: "Item 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 535.36,
   left: 172.56,
   width: 101.64,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Item 7 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 535.36,
   left: 289.523,
   width: 96.185,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Item 7 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 535.36,
   left: 400.072,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Item 8 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.44,
   left: 119.246,
   width: 52.200,
   height: 15.467
}
,
{
   page: 5,
   name: "Item 8 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.44,
   left: 172.56,
   width: 101.64,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.44,
   left: 288.836,
   width: 96.186,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Item 8 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.44,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.76,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "CALCULATE Amount Purchase Price PLUS Amount Item 7 Debit PLUS Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 602.68,
   left: 288.836,
   width: 96.186,
   height: 15.467
}
,
{
   page: 5,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Item 7 Credit PLUS Amount Item 8 Credit PLUS Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 602.68,
   left: 399.386,
   width: 85.374,
   height: 15.467
}
,
{
   page: 5,
   name: "Amount Seller Concession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 631.44,
   left: 331.08,
   width: 109.92,
   height: 13.08
}
,
{
   page: 5,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.64,
   left: 402.96,
   width: 165.00,
   height: 13.08
}
,
{
   page: 5,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 730.56,
   left: 186.84,
   width: 279.96,
   height: 13.08
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 480.6,
   left: 424.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 480.6,
   left: 471.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 629.64,
   left: 73.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan FHA", 
   isText: false,
   type: "checkbox",
   top: 629.64,
   left: 156.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan VA", 
   isText: false,
   type: "checkbox",
   top: 629.64,
   left: 204.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Bond", 
   isText: false,
   type: "checkbox",
   top: 629.64,
   left: 245.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 629.64,
   left: 294.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627.12,
   left: 341.04,
   width: 220.08,
   height: 12.36
}
,
{
   page: 6,
   name: "Amount FHA VA Closing Costs Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 659.52,
   left: 463.8,
   width: 94.92,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption At", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 56.4,
   left: 301.8,
   width: 69.96,
   height: 12.36
}
,
{
   page: 7,
   name: "Assumption Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 56.4,
   left: 389.64,
   width: 99.96,
   height: 12.36
}
,
{
   page: 7,
   name: "Assumption Rate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 69.6,
   left: 204.6,
   width: 60.0,
   height: 12.36
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Real Estate Taxes", 
   isText: false,
   type: "checkbox",
   top: 91.32,
   left: 63.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Property Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 91.32,
   left: 165.96,
   width: 10.111,
   height: 10.08
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Mortgage Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 91.32,
   left: 318.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Other", 
   isText: false,
   type: "checkbox",
   top: 111.148,
   left: 63.807,
   width: 10.080,
   height: 10.080
}
,
{
   page: 7,
   name: "AssumptionEscrow Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 108.24,
   left: 81.72,
   width: 465.00,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption Loan Transfer Fee Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 127.44,
   left: 310.44,
   width: 99.96,
   height: 12.36
}
,
{
   page: 7,
   name: "Percent Assumption Loan Interest Rate Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.64,
   left: 176.76,
   width: 75.00,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption New Payment Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 159.84,
   left: 78.48,
   width: 79.92,
   height: 12.36
}
,
{
   page: 7,
   name: "Assumption New Payment Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 159.84,
   left: 176.16,
   width: 110.16,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption Cash At Closing Increase Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 186.24,
   left: 267.96,
   width: 120.00,
   height: 12.36
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will", 
   isText: false,
   type: "checkbox",
   top: 221.16,
   left: 130.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not", 
   isText: false,
   type: "checkbox",
   top: 221.16,
   left: 174.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 248.76,
   left: 73.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseDelivery At Closing", 
   isText: false,
   type: "checkbox",
   top: 262.68,
   left: 73.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Assumption Release of Liability Paid By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 279.84,
   left: 293.4,
   width: 205.92,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption Release of Liability Max Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 293.76,
   left: 119.76,
   width: 84.96,
   height: 12.36
}
,
{
   page: 7,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 439.8,
   left: 392.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 439.8,
   left: 444.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.135,
   left: 352.08,
   width: 99.96,
   height: 11.705
}
,
{
   page: 8,
   name: "Checkbox Buyer will not occupy as primary residence", 
   isText: false,
   type: "checkbox",
   top: 525.48,
   left: 339.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Amount FHA Minimum Appraised Value", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.64,
   left: 422.455,
   width: 84.960,
   height: 12.36
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 473.16,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 473.16,
   left: 116.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoSelectsTitleCompany Seller", 
   isText: false,
   type: "checkbox",
   top: 693.72,
   left: 103.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Checkbox Abstract of Title", 
   isText: false,
   type: "checkbox",
   top: 733.32,
   left: 201.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoSelectsTitleCompany Buyer", 
   isText: false,
   type: "checkbox",
   top: 64.92,
   left: 103.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton TitleContainsOEC Will", 
   isText: false,
   type: "checkbox",
   top: 143.16,
   left: 366.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton TitleContainsOEC Will Not", 
   isText: false,
   type: "checkbox",
   top: 143.16,
   left: 411.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysOEC Buyer", 
   isText: false,
   type: "checkbox",
   top: 228.36,
   left: 72.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysOEC Seller", 
   isText: false,
   type: "checkbox",
   top: 228.36,
   left: 124.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysOEC Split", 
   isText: false,
   type: "checkbox",
   top: 228.36,
   left: 176.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysOEC Other", 
   isText: false,
   type: "checkbox",
   top: 228.36,
   left: 385.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "WhoPaysOEC Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.521,
   left: 431.64,
   width: 135.00,
   height: 11.679
}
,
{
   page: 12,
   name: "Website Metro District", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 338.413,
   left: 62.76,
   width: 500.04,
   height: 12.827
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysTaxCertificate Seller", 
   isText: false,
   type: "checkbox",
   top: 361.32,
   left: 276.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysTaxCertificate Buyer", 
   isText: false,
   type: "checkbox",
   top: 361.32,
   left: 327.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox Group ILCorSurvey New ILC", 
   isText: false,
   type: "checkbox",
   top: 581.88,
   left: 306.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox Group ILCorSurvey New Survey", 
   isText: false,
   type: "checkbox",
   top: 595.56,
   left: 81,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "ILCorSurvey New Survey in the form of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.215,
   left: 211.08,
   width: 194.88,
   height: 12.185
}
,
{
   page: 13,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 629.16,
   left: 273.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 629.16,
   left: 324.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Radiobutton WhoPaysNewILCorSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 688.68,
   left: 131.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Radiobutton WhoPaysNewILCorSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 688.68,
   left: 183,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "WhoPaysNewILCorSurvey Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 686.68,
   left: 243.48,
   width: 320.04,
   height: 12.84
}
,
{
   page: 13,
   name: "Delivery ILC", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.5891,
   left: 243.84,
   width: 315.00,
   height: 11.5309
}
,
{
   page: 15,
   name: "Occupancy Agreements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 404.511,
   left: 80.202,
   width: 501.282,
   height: 65.224
}
,
{
   page: 15,
   name: "Other Documents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 636.875,
   left: 85.7458,
   width: 497.1652,
   height: 112.4707
}
,
{
   page: 16,
   name: "Conditional On Sale Of Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.914,
   left: 62.76,
   width: 504.96,
   height: 12.966
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does", 
   isText: false,
   type: "checkbox",
   top: 442.2,
   left: 95.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does Not", 
   isText: false,
   type: "checkbox",
   top: 442.2,
   left: 142.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Well There is no well", 
   isText: false,
   type: "checkbox",
   top: 476.28,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does", 
   isText: false,
   type: "checkbox",
   top: 476.28,
   left: 191.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does Not", 
   isText: false,
   type: "checkbox",
   top: 476.28,
   left: 238.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are", 
   isText: false,
   type: "checkbox",
   top: 648.36,
   left: 420.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are Not", 
   isText: false,
   type: "checkbox",
   top: 648.36,
   left: 463.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 718.08,
   left: 62.76,
   width: 420.00,
   height: 12.36
}
,
{
   page: 18,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 151.08,
   left: 64.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 151.08,
   left: 178.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 151.08,
   left: 293.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 151.08,
   left: 406.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 165.24,
   left: 64.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton DeedType Deed Other", 
   isText: false,
   type: "checkbox",
   top: 165.24,
   left: 214.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 162.76,
   left: 232.92,
   width: 219.96,
   height: 13.32
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 398.04,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 398.04,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 398.04,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 417.24,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "ClosingServicesFeePaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.76,
   left: 231.48,
   width: 320.04,
   height: 13.32
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 520.68,
   left: 189.96,
   width: 10.735,
   height: 11.389
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 520.68,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 520.68,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 520.68,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 572.28,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 572.28,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 572.28,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 572.28,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 610.68,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 610.68,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 610.68,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 610.68,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 647.4,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 647.4,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 647.4,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 647.4,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 684.12,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 684.12,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 684.12,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 684.12,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 735.96,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 735.96,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 735.96,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 735.96,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Amount Water Transfer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.172,
   left: 70.32,
   width: 84.96,
   height: 11.908
}
,
{
   page: 19,
   name: "Checkbox Group WaterTransferFees Water DistrictMunicipality", 
   isText: false,
   type: "checkbox",
   top: 80.76,
   left: 99.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Checkbox Group WaterTransferFees Augmentation Membership", 
   isText: false,
   type: "checkbox",
   top: 98.28,
   left: 99.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Checkbox Group WaterTransferFees Water Stock", 
   isText: false,
   type: "checkbox",
   top: 80.76,
   left: 253.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Checkbox Group WaterTransferFees Small Domestic Water Company", 
   isText: false,
   type: "checkbox",
   top: 98.28,
   left: 253.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Checkbox Group WaterTransferFees Other", 
   isText: false,
   type: "checkbox",
   top: 98.798,
   left: 419.891,
   width: 10.080,
   height: 10.080
}
,
{
   page: 19,
   name: "WaterTransferFees Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 97.148,
   left: 438.0,
   width: 114.96,
   height: 11.972
}
,
{
   page: 19,
   name: "Radiobutton WaterTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 133.32,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton WaterTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 133.32,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton WaterTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 133.32,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton WaterTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 133.32,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton UtilityTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 181.56,
   left: 189.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton UtilityTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 181.56,
   left: 242.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton UtilityTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 181.56,
   left: 293.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton UtilityTransferFeePaidBy Buyer NA", 
   isText: false,
   type: "checkbox",
   top: 181.56,
   left: 502.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 257.88,
   left: 103.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 474.12,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 494.04,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 527.64,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 524.853,
   left: 133.2,
   width: 405.0,
   height: 12.627
}
,
{
   page: 19,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 547.32,
   left: 205.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 547.32,
   left: 335.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Other Prorations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 603.8,
   left: 72.6549,
   width: 479.3271,
   height: 13.112
}
,
{
   page: 19,
   name: "Radiobutton AssociationAssessmentsObligation Buyer", 
   isText: false,
   type: "checkbox",
   top: 711.96,
   left: 79.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton AssociationAssessmentsObligation Seller", 
   isText: false,
   type: "checkbox",
   top: 711.96,
   left: 132.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 20,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 43.2,
   left: 328.32,
   width: 221.051,
   height: 12.36
}
,
{
   page: 20,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 134.64,
   left: 428.28,
   width: 56.64,
   height: 12.36
}
,
{
   page: 21,
   name: "Checkbox Specific Performance", 
   isText: false,
   type: "checkbox",
   top: 222.36,
   left: 108.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.48,
   left: 62.76,
   width: 390.00,
   height: 12.36
}
,
{
   page: 23,
   name: "Checkbox PaysBuyerBrokerage Seller", 
   isText: false,
   type: "checkbox",
   top: 162.36,
   left: 92.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 160.458,
   left: 109.966,
   width: 40.080,
   height: 11.625
}
,
{
   page: 23,
   name: "Amount Seller Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 160.84,
   left: 266.446,
   width: 79.920,
   height: 11.625
}
,
{
   page: 23,
   name: "Checkbox PaysBuyerBrokerage Buyer", 
   isText: false,
   type: "checkbox",
   top: 207.96,
   left: 92.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.44,
   left: 109.966,
   width: 40.080,
   height: 11.625
}
,
{
   page: 23,
   name: "Amount Buyer Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.44,
   left: 266.446,
   width: 75.000,
   height: 11.625
}
,
{
   page: 23,
   name: "Checkbox PaysBuyerBrokerage Sellers Brokerage", 
   isText: false,
   type: "checkbox",
   top: 253.56,
   left: 92.04,
   width: 10.735,
   height: 10.735
}
,
{
   page: 23,
   name: "Percent Seller Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 252.04,
   left: 109.966,
   width: 40.080,
   height: 11.625
}
,
{
   page: 23,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 252.04,
   left: 267.101,
   width: 75.000,
   height: 11.625
}
,
{
   page: 23,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 345.22,
   left: 50.1794,
   width: 541.7616,
   height: 406.2141
}
,
{
   page: 24,
   name: "Checkbox ChecklistItem Post-Closing Occupancy Agreement", 
   isText: false,
   type: "checkbox",
   top: 245.84,
   left: 108.12,
   width: 10.08,
   height: 10.735
}
,
{
   page: 24,
   name: "Additional Provisions 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 37.964,
   left: 53.0184,
   width: 541.7616,
   height: 115.491
}
,
{
   page: 24,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 183.928,
   left: 54.8243,
   width: 540.3897,
   height: 63.600
}
,
{
   page: 24,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 290.183,
   left: 60.4708,
   width: 532.1562,
   height: 79.190
}
,
{
   page: 24,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 415.437,
   left: 132.324,
   width: 450.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 453.48,
   left: 136.638,
   width: 444.960,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.48,
   left: 136.638,
   width: 170.040,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 468.48,
   left: 449.118,
   width: 135.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 483.48,
   left: 136.638,
   width: 450.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507.4,
   left: 135.638,
   width: 450.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 545.003,
   left: 135.311,
   width: 444.960,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.883,
   left: 135.311,
   width: 170.040,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.883,
   left: 447.791,
   width: 135.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 575.161,
   left: 135.311,
   width: 450.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 597.803,
   left: 135.311,
   width: 450.000,
   height: 11.542
}
,
{
   page: 24,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 647.243,
   left: 135.311,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 435.48,
   left: 108.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 435.48,
   left: 155.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton BuyerBrokerRelationship Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 519.48,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton BuyerBrokerRelationship TransactionBroker", 
   isText: false,
   type: "checkbox",
   top: 534.6,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton BuyerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 549.48,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 51.707,
   left: 135.166,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 89.747,
   left: 135.166,
   width: 444.960,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.507,
   left: 135.166,
   width: 170.040,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.507,
   left: 447.646,
   width: 135.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 119.517,
   left: 135.444,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 147.317,
   left: 136.008,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 185.237,
   left: 135.008,
   width: 444.960,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.117,
   left: 135.663,
   width: 170.040,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.117,
   left: 448.143,
   width: 135.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 217.056,
   left: 135.476,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 233.979,
   left: 136.292,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 288.699,
   left: 137.292,
   width: 450.000,
   height: 11.542
}
,
{
   page: 25,
   name: "Buyer Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 641.204,
   left: 199.615,
   width: 354.960,
   height: 13.505
}
,
{
   page: 25,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 657.084,
   left: 199.615,
   width: 354.960,
   height: 13.505
}
,
{
   page: 25,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 671.964,
   left: 199.615,
   width: 354.960,
   height: 13.505
}
,
{
   page: 25,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 687.084,
   left: 199.615,
   width: 354.960,
   height: 13.5055
}
,
{
   page: 25,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 716.6192,
   left: 395.27,
   width: 90.00,
   height: 13.5055
}
,
{
   page: 25,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.9122,
   left: 200.947,
   width: 185.345,
   height: 13.5055
}
,
{
   page: 26,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 159.113,
   left: 394.381,
   width: 90.000,
   height: 12.196
}
,
{
   page: 26,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 161.455,
   left: 199.044,
   width: 186.187,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 132.993,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.233,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 88.353,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 73.233,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 58.353,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 43.473,
   left: 199.381,
   width: 354.960,
   height: 12.196
}
,
{
   page: 26,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 231.0,
   left: 108.36,
   width: 10.735,
   height: 10.08
}
,
{
   page: 26,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 231.0,
   left: 155.4,
   width: 10.08,
   height: 10.735
}
,
{
   page: 26,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 315,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 330.12,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "Radiobutton SellerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 345,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "Checkbox SellerBrokerageFirmPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 389.88,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "Checkbox SellerBrokerageFirmPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 404.76,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "Checkbox SellerBrokerageFirmPaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 420.6,
   left: 75.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 26,
   name: "SellerBrokerageFirmPaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.138,
   left: 122.28,
   width: 429.00,
   height: 11.542
}
,
{
   page: 26,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 483.64,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 498.52,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 513.4,
   left: 199.135,
   width: 354.960,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 528.28,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.718,
   left: 198.983,
   width: 183.618,
   height: 10.824
}
,
{
   page: 26,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 557.28,
   left: 393.135,
   width: 90.000,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 599.935,
   left: 199.135,
   width: 354.960,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 614.16,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 629.04,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 644.575,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 659.04,
   left: 198.48,
   width: 354.96,
   height: 10.824
}
,
{
   page: 26,
   name: "Seller CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 689.8,
   left: 198.48,
   width: 354.96,
   height: 10.8243
}
,
{
   page: 26,
   name: "Signature CoAgent Seller", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.1187,
   left: 199.946,
   width: 181.561,
   height: 10.8243
}
,
{
   page: 26,
   name: "Date Signature CoAgent Seller", 
   fontSize: 9,
   type: "date",
   top: 715.92,
   left: 392.48,
   width: 90.00,
   height: 10.8243
}
] }
